export default {
  delay: 0
}
